import React from 'react';
import type { FormatterProps } from './type';
import ReactTooltip from 'react-tooltip';
import { MedicationEventTO } from '../../../../../lib';

const AmountMedicineFormatter = ({ row }: FormatterProps) => {
  const medicinesRaw: MedicationEventTO[] =
    row?.last_episode?.episodeEvents?.medications;
  if (!Array.isArray(medicinesRaw) || medicinesRaw.length === 0) {
    return <span>-</span>;
  }
  const medicinesFiltered = medicinesRaw.filter((med) => {
    if (med?.detail?.homeMedication) return false;
    // TODO AM-363 med?.detail?.orderstatuscode
    // status === 'AUA1'
    // this may need an API update in function getLatestEpisodeObservationAndMeds
    const status = med?.detail?.fhir?.status || med?.detail?.orderstatuscode;
    if (typeof status === 'string') {
      return (
        status.toLowerCase() === 'completed' ||
        status.toLowerCase() === 'active'
      );
    }
    return true;
  });
  const medicines = Array.from(
    medicinesFiltered.reduce((acc, med) => {
      const key = (med?.name ?? '').trim().toLowerCase();
      if (!key) return acc;
      if (!acc.has(key)) acc.set(key, med);
      return acc;
    }, new Map<string, MedicationEventTO>()),
  ).map(([, med]) => med);
  if (medicines.length === 0) return <span>-</span>;
  return (
    <>
      <span
        data-tip
        data-for={`medicines-${row.id}-${medicines.length}`}
        style={{
          color: '#5C6469',
          textDecorationLine: 'underline',
        }}
      >
        {medicines.length}
      </span>
      <ReactTooltip
        id={`medicines-${row.id}-${medicines.length}`}
        effect="solid"
      >
        {medicines.map((med: MedicationEventTO, index: number) => (
          <div key={index} className="mb-1">
            {med.name} {med.dosage}
          </div>
        ))}
      </ReactTooltip>
    </>
  );
};

export default AmountMedicineFormatter;
